import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setGetCreditLimits } from '../../store/thunk/setGetCreditLimits';
import { setGetCreditLive } from '../../store/thunk/setGetCreditLive';
import { setGetListGroups } from '../../store/thunk/setGetListGroups';
import Title from '../../components/title';
import Credit from '../../components/credit';
import CashierItem from '../../components/cashierItem';
import {useStyles} from './helper';

const Line = () => {
    const dispatch = useDispatch();
    const classes = useStyles();

    React.useEffect(() => {
        dispatch(setGetCreditLimits());
        dispatch(setGetCreditLive());
        dispatch(setGetListGroups({ group: '', hide: false}))
    }, []);

    const credit = useSelector(state => state.creditMobile.list);
    const groups = useSelector(state => state.creditMobile.groups);
    const creditLive = useSelector(state => state.creditMobile.live);

    return (
        <div className={classes.root}>
            <Title label="Кредитная линия" />
            <Credit slotCredit={credit} liveCredit={creditLive} />
            <div className={classes.wrap}>
                <div className={classes.block}>
                    <span className={classes.helper}>Кредиты на кассах</span>
                </div>
                {
                    groups.list.map((item, key) => <CashierItem item={item} keys={key} key={key}/>)
                }
            </div>
        </div>
    )
}

export default Line;